export const DOWNLOAD_SONG_VERSION = 'DOWNLOAD_VERSION';
export const DOWNLOAD_SONG_BUNDLE = 'DOWNLOAD_SONG_BUNDLE'; 
export const MOST_DOWNLOAD_SONG_TODAY = 'MOST_DOWNLOAD_SONG_TODAY';
export const DOWNLOAD_HISTORY = 'DOWNLOAD_HISTORY';
export const CUSTOMER_DOWNLOADS = 'CUSTOMER_DOWNLOADS';
export const EXPRESS_DOWNLOADS = 'EXPRESS_DOWNLOADS';